import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { DownloadDocument, deleteMultipleImages } from "../Actions/CommonAPI";
import userRoles from '../helpers/role';
import Moment from 'moment';
import { getOtherTask, getPendingTask } from "../Actions/ShipViewAPI";
import AddIcon from "../UIComponents/AddIcon";
import { confirmAlert } from 'react-confirm-alert';
import API from "../helpers/api";
import axios from "axios";
import swal from "sweetalert";
import { toast } from "react-toastify";

let userrole = localStorage.getItem("UserRoles");
let shipId = JSON.parse(localStorage.getItem("shipId"));

class StaffPendingTasks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0
    };
    this.onPaginatorChange = this.onPaginatorChange.bind(this);
  }

  componentDidMount() {
    // ;
    // const { dispatch, match } = this.props;
    // let shipId = parseInt(match.params.shipId);
    // if (shipId) {      
    //   // dispatch(getPendingTask(shipId));
    // }
  }

  renderPopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Download Last Service Report</label>
        </Popover.Content>
      </Popover>
    );
  }
  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }
  showEditPODetailPanel = (item) => {
    const { history } = this.props;
    if (window.location.href.indexOf("/Home/Ship/Staff/Tasks") !== -1) {
      //  this.props.dispatch({ type: "TaskDetails", data: item });
      // this.props.history.push(`/Home/Ship/Staff/Tasks/POUpdate`);
      this.props.history.push(`/Home/Staff/POValidation/${item.shipId}/${item.purchaseOrderId}`);
      window.scrollTo(0, 0);
    }
  }

  showPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "POView", data: false });
    dispatch({ type: "EditPOView", data: false });
    history.push(`/Home/POView/${shipId}/${poId}`);
  };

  getPoInfo = (item) => {
    const { dispatch } = this.props;
    this.setState({ modalIsOpen: true })
  }

  AddOtherTask = () => {
    const { dispatch, match } = this.props;
    this.props.history.push(`/Home/Ship/${match.params.shipId}/Othertask`);
    dispatch({ type: "GetOtherTaskList", data: "" });
  };

  render() {
    const { pendingTasks, OtherTasks } = this.props;

    return (
      <div className="pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
              <div className="card-body">
                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                  {/* {currentRole === userRoles.client || currentRole === userRoles.mmpl ? "Ship's Pending Tasks" : "My Pending Tasks"} */}
                  Ship's Pending Tasks
                </h5>
              </div>
            </div>
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">
                  {this.renderCardPendingData()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {pendingTasks.data && pendingTasks.data.length ? (
          <Paginator
            first={this.state.currentPage}
            rows={pendingTasks.pagination.pageSize}
            totalRecords={pendingTasks.pagination.totalcount ? pendingTasks.pagination.totalcount : 0}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
          <div className="card" style={{ overflow: "hidden", position: "relative" }}>
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                No Tasks
              </h6>
            </div>
          </div>
        )}

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className=" card MM-card-header" style={{ backgroundColor: "white" }}>
              <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                Hazardous Material Removal
                </h5>
                {userrole === "admin" || userrole === "mmpl" ?
                  <div className="m-1 flex"
                    onClick={() =>
                      this.AddOtherTask()
                    }>
                    <span className="card-title m-auto">Add</span>
                    <AddIcon />
                  </div>
                  : null}
              </div>
            </div>
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">
                  {this.renderCardOtherData()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {OtherTasks.data && OtherTasks.data.length ? (
          <Paginator
            first={this.state.currentPage}
            rows={OtherTasks.pagination.pageSize}
            totalRecords={OtherTasks.pagination.totalcount ? OtherTasks.pagination.totalcount : 0}
            onPageChange={(e) => this.onPaginatorChangeevent(e)}>
          </Paginator>
        ) : (
          <div className="card" style={{ overflow: "hidden", position: "relative" }}>
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                No Tasks
              </h6>
            </div>
          </div>
        )}

      </div>
    );
  }

  onPaginatorChange(event) {
    const { staffShipId, dispatch,match } = this.props;
    this.setState({ currentPage: event.first, });
    dispatch(getPendingTask(parseInt(match.params.shipId), event.page + 1));
  }

  onPaginatorChangeevent(event) {
    const { staffShipId, dispatch ,match} = this.props;
    this.setState({ currentPage: event.first, });
    dispatch(getOtherTask(parseInt(match.params.shipId), event.page + 1));
  }

  renderCardPendingData = () => {
    const { ShowStaffPendingTaskPanel, pendingTasks } = this.props;
    return pendingTasks.data && pendingTasks.data.length
      ? pendingTasks.data.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
            {/* {item.totalEquipment ? (
              <div className="arrow-left-red"></div>
            ) : (
                <div className="arrow-left-green"></div>
              )} */}
            <div className="px-3 py-2">
              <div className="resource-list-auth-date">
                <div className="row mx-0">
                  <div className={`${userrole === userRoles.staff ? "col-sm-10 col-md-11 col-10 col-m-auto" : "col-sm-10 col-md-11 col-10 col-m-auto"}col-m-auto`}>
                    <div className="row">
                      {/* <div className="col-sm-12 mb-1">
                        <h6 className="resource-list-title title mb-0" style={{ cursor: "pointer" }}
                        //  onClick={() => this.showPODetailPanel(item.shipId, item.purchaseOrderId)}
                        >
                          {item.itemDescription}
                        </h6>
                      </div> */}
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3"}>
                        <span>
                          <strong>PO No : </strong>
                          <span className="italicFont">{item.poNo}</span>
                        </span>
                      </div>
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3"}>
                        <span>
                          <strong>PR No : </strong>
                          <span className="italicFont">{item.prNo}</span>
                        </span>
                      </div>
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3"}>
                        <span>
                          <strong>PO Date : </strong>
                          <span className="italicFont">{Moment(new Date(Date.parse(item.poDate))).format('DD MMM YYYY')}</span>
                        </span>
                      </div>
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3"}>
                        <span>
                          <strong>Quantity : </strong>
                          <span className="italicFont">{item.quantity}</span>
                        </span>
                      </div>
                      {/* <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3"}>
                        <span>
                          <strong>SDoc : </strong>
                          <span className="italicFont">{item.sDocAttachmentName}</span>
                          {item.sDocAttachmentName ?
                            <i class="fa fa-download click ml-1" onClick={() => this.downloadAttachment(item.sDocAttachmentName, item.sDocAttachmentGuid)}></i>
                            : null}
                        </span>
                      </div>
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3"}>
                        <span>
                          <strong>MD : </strong>
                          <span className="italicFont">{item.mdAttachmentName}</span>
                          {item.mdAttachmentName ?
                            <i class="fa fa-download click ml-1" onClick={() => this.downloadAttachment(item.mdAttachmentName, item.mdAttachmentGuid)}></i>
                            : null}
                        </span>
                      </div> */}
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-12" : "col-sm-6"}>
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont ">{item.vesselName}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                    {userrole === userRoles.staff ?
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.updatePopover()} >
                        <i className="fa fa-edit fa-3x click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '35px' }} onClick={() => this.showEditPODetailPanel(item)}>
                        </i>
                      </OverlayTrigger>
                      :
                      <i className="fa fa-eye click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }}
                        onClick={() => this.showPODetailPanel(item.shipId, item.purchaseOrderId)}
                      >
                      </i>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }) : null;
  };

  renderCardOtherData = () => {
    const { ShowStaffPendingTaskPanel, OtherTasks } = this.props;
    return OtherTasks.data && OtherTasks.data.length
      ? OtherTasks.data.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
            <div className="px-3 py-2">
              <div className="resource-list-auth-date">
                <div className="row mx-0">
                  <div className={`${userrole === userRoles.staff ? "col-sm-10 col-md-10 col-10 col-m-auto" : "col-sm-10 col-md-11 col-10 col-m-auto"}col-m-auto mb-1`}>
                    <div className="row">
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>Task : </strong>
                          <span className="italicFont">{item.task}</span>
                        </span>
                      </div>
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>Description : </strong>
                          <span className="italicFont">{item.description}</span>
                        </span>
                      </div>
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>DeadLine : </strong>
                          <span className="italicFont">{Moment(new Date(Date.parse(item.deadLine))).format('DD MMM YYYY')}</span>
                        </span>
                      </div>
                      {userrole === "mmpl" || userrole === "admin" ?
                        <div className={ShowStaffPendingTaskPanel ? "col-sm-6" : "col-sm-3 mb-1"}>
                          <span>
                            <strong>Status : </strong>
                            <span className="italicFont">{item.isCompleted ? "Completed" : "Pending"}</span>
                          </span>
                        </div> : null}
                      <div className={ShowStaffPendingTaskPanel ? "col-sm-12" : "col-sm-9 mb-1"}>
                        <strong>Attachments : </strong>{
                          item.attachments && item.attachments.map((items, index) => {
                            return (
                              <span class="italicFont ">{items.attachmentName}
                                {item && item.attachments ?
                                  <>
                                    <i class="fa fa-download click ml-1" onClick={() => this.downloadDocument(items)}></i>
                                    {userrole === 'admin' || userrole === 'mmpl' ? <i class="fa fa-trash click ml-1" onClick={() => this.DeleteDocuments(item, items)}></i> : ""}
                                    {item.attachments.length === 1 ? "" : item.attachments.length === index + 1 ? "" : <strong>,  &nbsp; </strong>}
                                  </>
                                  : null}
                              </span>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                  {userrole === "admin" || userrole === "mmpl" ?
                    <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                      <div className="row">
                        <div className="col-sm-4 mt-1">
                          <i className="fa fa-edit click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }}
                            onClick={() => this.showOtherTask(item)}
                          >
                          </i>
                        </div>
                        <div className="col-sm-5">
                          <i className="fa fa-trash click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }}
                            onClick={() => this.deleteOtherTask(item)}
                          >
                          </i>
                        </div>
                      </div>
                    </div>
                    : (userrole === "staff" ?
                      <div className="col-sm-2 col-md-2 col-m-auto">
                        <button class="btn btn-secondary btn-xs btn-conf-edit" data-confirmation="confirm" style={{ width: "120px" }} onClick={() => this.completeTask(item)}>
                          <i class="glyphicon glyphicon-ok"></i> Completed On
                        </button>
                      </div>
                      : null)}

                </div>
              </div>
            </div>
          </div >
        );
      }) : null;
  };

  completeTask = (item) => {
    var today = new Date();
    var currentDate = Moment(new Date(Date.parse(today))).format(
      "YYYY-MM-DD"
    )
    const { dispatch } = this.props;
    confirmAlert({
      message: 'Are you sure want to confirm?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            item.isCompleted = true;
            item.completedDate = currentDate;
            let url = `${API.PutOtherTask}`;
            axios.put(url, item)
              .then((response) => {
                if (response.data) {
                  dispatch(getOtherTask(shipId, 1));
                  toast.success('Updated successfully.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                dispatch({
                  type: "putOtherTaskSuccess",
                  data: response.data
                })
              })
              .catch((error) => {
                dispatch({
                  type: "putOtherTaskFailure",
                  error: "ERROR"
                })
              })
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    });
  }

  showOtherTask = (item) => {
    const { history, dispatch, match } = this.props;
    const { params } = match;
    const { shipId } = params;
    dispatch({ type: "EditOtherTask", data: item });
    history.push(`/Home/Ship/${shipId}/OthertaskEdit`);
  };

  deleteOtherTask = (item) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipId } = params;
    confirmAlert({
      message: 'Are you sure want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let url = `${API.PutOtherTask}`;
            let data = {
              shipTaskId: item.shipTaskId,
              shipId: parseInt(shipId),
              task: item.task,
              description: item.description,
              deadLine: item.deadLine,
              completedDate: item.completedDate,
              isCompleted: false,
              isDeleted: true,
              attachments: [],
              modifiedBy: ""
            };
            axios.put(url, data)
              .then((response) => {
                if (response.data) {
                  toast.success(' Deleted successfully.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  dispatch(getOtherTask(parseInt(shipId), 1));
                }
                dispatch({
                  type: "deleteOtherTaskSuccess",
                  data: response.data,
                })
              })
              .catch((error) => {
                dispatch({
                  type: "deleteOtherTaskFailure",
                  error: "ERROR"
                })
              })
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    });
  };

  downloadDocument = (attachmentDetail) => {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(attachmentDetail.attachmentName, attachmentDetail.attachmentGuid));
  }

  DeleteDocuments = (item, items) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipId } = params;
    confirmAlert({
      message: 'Are you sure want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let url = `${API.PutOtherTask}`;
            let data = {
              shipTaskId: item.shipTaskId,
              shipId: parseInt(shipId),
              task: item.task,
              description: item.description,
              deadLine: item.deadLine,
              completedDate: item.completedDate,
              isCompleted: false,
              isDeleted: false,
              attachments: [
                {
                  attachmentId: items.attachmentId,
                  attachmentName: items.attachmentName,
                  attachmentGuid: items.attachmentGuid,
                  isDeleted: true
                }
              ],
              modifiedBy: ""
            };
            axios.put(url, data)
              .then((response) => {
                if (response.data) {
                  toast.success('Attachment Deleted successfully.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  dispatch(getOtherTask(parseInt(shipId), 1));
                }
                dispatch({
                  type: "deleteDocumentSuccess",
                  data: response.data,
                })
              })
              .catch((error) => {
                dispatch({
                  type: "deleteDocumentFailure",
                  error: "ERROR"
                })
              })
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    });
  }

  downloadAttachment = (FileName, Guid) => {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(FileName, Guid));
  }
  ShowSidePanel = (id) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/EquipmentEdit/${id}/single`);
  };

  editEquipmentDetails = (id, type) => {
    this.props.dispatch({ type: "EditEquipmentDetails", data: true });
    this.props.history.push(`/Home/ShipDetails/EquipmentEdit/${id}/${type}`);
  };
}

function mapStateToProps(state) {
  return {
    //BY BALU MOORTHI
    showEquipmentDetails: false,
    editShipDetailsPane: false,
    editEquipmentDetailsPane: false,
    editPOView: state.SidePanReducer.EditPOView || false,
    editPendingTaskPresence: state.SidePanReducer.EditPendingTaskPresence || false,
    editPendingTaskRevision: state.SidePanReducer.EditPendingTaskRevision || false,
    pendingTasks: state.ShipViewReducer.PendingTasks || [],
    OtherTasks: state.ShipViewReducer.OtherTasks || [],
    currentRole: state.SidePanReducer.UserRole || null,
    ShowStaffPendingTaskPanel: state.SidePanReducer.ShowStaffPendingTaskPanel || false,
    staffShipId: state.MMPLDashboardReducer.StaffShipId
    // pendingTaskPresenceList: state.ShipViewReducer.PendingTask || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StaffPendingTasks)
);
